import "./Landlords.module.css";
import StudioCommandHeader from "@/reusable_sections/Header";
import ManagementSolutions from "./sections/ManagementSolutions";
import ValuationRequest from "./sections/ValuationRequest";
import Footer from "@/reusable_sections/Footer";
export default function LandlordsPage() {
  return <div>
      <StudioCommandHeader />
      <ManagementSolutions />
      <ValuationRequest />
      <Footer />
    </div>;
}